import React from "react";

// Shared annotation helpers for the actual-vs-forecast charts. The cost-analyzer's
// "Daily spend" chart and the forecast-predictability "Forecast vs budget" chart show the
// same thing — a run-rate line that hands over to a forecast fan — so they derive their
// diagnostic references from one place and read identically.

// singleSeriesMeta derives the diagnostic references for an actual/forecast line: where
// the actual line ends (the settle boundary the forecast takes over from), the actual
// run-rate average, the peak actual day, and the endpoint indices used for direct labels.
export function singleSeriesMeta(data) {
  const actuals = data.filter((d) => d.actual != null);
  let boundaryIdx = -1;
  data.forEach((d, i) => { if (d.actual != null) boundaryIdx = i; });
  const boundary = boundaryIdx >= 0 ? data[boundaryIdx].date : null;
  const avg = actuals.length ? actuals.reduce((s, d) => s + d.actual, 0) / actuals.length : null;
  let peak = null;
  for (const d of actuals) { if (peak == null || d.actual > peak.actual) peak = d; }
  const hasForecast = data.some((d) => d.forecast != null);
  let lastForecastIdx = -1;
  data.forEach((d, i) => { if (d.forecast != null) lastForecastIdx = i; });
  return {
    boundary,
    boundaryIdx,
    avg,
    peak,
    hasForecast,
    lastActualIdx: boundaryIdx,
    lastForecastIdx,
    firstDate: data.length ? data[0].date : null,
    lastDate: data.length ? data[data.length - 1].date : null,
  };
}

// endLabel renders a direct label at ONE point of a line (its endpoint), so the analyst
// reads "Actual"/"Forecast" off the line itself instead of a detached legend.
export function endLabel(text, idx, color) {
  const Cmp = (props) => {
    if (props.index !== idx || props.x == null || props.y == null) return null;
    return (
      <text x={props.x} y={props.y} dx={6} dy={4} fontSize={11} fontWeight={600} fill={color}>
        {text}
      </text>
    );
  };
  return Cmp;
}
